class PasswordToggle extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const parentElement = this.parentElement;
        this.input = parentElement.querySelector("input[type=password]");
        if (this.input) {
            this.init();
        } else {
            
        }
    }

    init() {
        
        this.addEventListener('click', () => this.togglePasswordVisibility());
        this.updateIcon(this.input.type);
    }

    togglePasswordVisibility() {
        const type = this.input.type === 'password' ? 'text' : 'password';
        this.input.type = type;
        this.updateIcon(type);
    }

    updateIcon(type) {
        if (type === 'text') {
            this.innerHTML = `
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye" viewBox="0 0 16 16">
                    <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z"/>
                    <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0"/>
                </svg>
            `;
        } else {
            this.innerHTML = `
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <g clip-path="url(#clip0_4282_8533)">
                        <path d="M8.00004 3.99998C10.6957 3.99998 13.1894 5.52465 14.5787 7.99998C14.1074 8.83998 13.5064 9.56731 12.8157 10.1656L13.761 11.111C14.6317 10.339 15.366 9.39864 15.9137 8.33231C16.0204 8.12498 16.0204 7.87498 15.9137 7.66765C14.383 4.68831 11.414 2.66665 8.00004 2.66665C7.1867 2.66665 6.39937 2.78465 5.65004 2.99998L6.76237 4.11231C7.16804 4.04098 7.58104 3.99998 8.00004 3.99998Z" fill="black"/>
                        <path d="M1.13804 0.195312L0.19537 1.13798L3.20137 4.14398C1.89704 5.01998 0.816036 6.23931 0.0767031 7.68698C-0.0229635 7.88231 -0.0229635 8.11764 0.0767031 8.31298C1.60404 11.303 4.5787 13.3333 8.00004 13.3333C9.27837 13.3333 10.4944 13.0496 11.596 12.5386L14.862 15.8046L15.8047 14.862L1.13804 0.195312ZM8.00004 12C5.30304 12 2.8107 10.4756 1.42137 7.99998C2.1047 6.78265 3.05537 5.79698 4.16504 5.10765L6.1967 7.13931C6.07204 7.40031 6.00004 7.69131 6.00004 7.99998C6.00004 9.10464 6.89537 9.99998 8.00004 9.99998C8.3087 9.99998 8.5997 9.92798 8.8607 9.80331L10.5747 11.5173C9.7597 11.83 8.8917 12 8.00004 12Z" fill="black"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_4282_8533">
                            <rect width="16" height="16" fill="white"/>
                        </clipPath>
                    </defs>
                </svg>
            `;
        }
    }
}

customElements.define("password-toggle", PasswordToggle);